import { getType, Reducer } from 'typesafe-actions'

import { NavMenuState } from './types'

import { NavMenuActions } from './actions'

export const initialState: NavMenuState = {
  selectedMenuItem: undefined
}

export const navMenuReducer: Reducer<NavMenuState, NavMenuActions> = (state = initialState, action) => {
  switch (action.type) {
    case getType(NavMenuActions.toggle): {
      return {
        selectedMenuItem: action.payload.name
      }
    }
    case getType(NavMenuActions.close): {
      return {
        selectedMenuItem: undefined
      }
    }
    default:
      return state
  }
}
